import {useSelector} from 'react-redux';

import appContent from '@/services/content/appContent';
import {selectConnectionError} from '@/state/selectors/mw';

const useConnectionErrorContent = () => {
    const connectionError = useSelector(selectConnectionError);
    const {code: connectionErrorCode} = connectionError || {};
    const connectionErrorsContent = appContent.getConnectionErrorsContent();

    // Find content for the specific error code
    const errorContent = connectionErrorsContent?.find((x) => x.errorCodes?.includes(connectionErrorCode));

    // If no specific error content found, use the default content (with null/empty errorCodes)
    const defaultContent = connectionErrorsContent?.find((x) => !x.errorCodes?.length);

    // Use specific error content if found, otherwise fallback to default
    const content = errorContent || defaultContent || {};
    const {popup, notificationTitle, notificationDescription} = content;

    return {
        popup,
        notificationTitle,
        notificationDescription,
    };
};

export default useConnectionErrorContent;
